/**
 * Stable store/navigation key for a library. Runtime is included so multiple
 * source packages with the same name (e.g. Node + PHP both "sdn-test-simple-car") do not overwrite each other.
 */
export const getLibraryStoreKey = (runtimeName: string, name: string): string => `${runtimeName}:${name}`
